import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,DownloadOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import * as serverconfig from '../serverconn'
import { ReportEmailControls, submitReportWithEmail, reportSearchButtonLabel, REPORT_KEYS, initialReportEmailState } from '../reportEmailUtils';
import CurrencyFormat from 'react-currency-format';
import {
  Col,
  Row,
} from 'reactstrap';
import * as reactstrp from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import '../tablestyle.css'; // Create this CSS file for custom styles


var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;



var token= ''
var sacco= ''
var bizuserid= ''

class ReportToPrint extends React.Component {

    state = {
    ...initialReportEmailState(),
      companyprofile:{},
    };
  
    componentDidMount(){
      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }
      

      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }
  
      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })

    }


   //calculate total of issuance
   calculateTotalofIssuance=()=>{
    var totalofissuances=0
    this.props.loanissues.map(
      (item)=>{
        totalofissuances+=Number(item.approvedamount)
      })

    return totalofissuances.toFixed(2);
   }


   //calculate total principle in
   calculateTotalPrincipleIn=()=>{
    var total=0
    this.props.loanrepayments.map(
      (item)=>{
        total+=Number(item.principle_paid)
      })

    return total.toFixed(2);
   }

   calculateTotalInterestIn=()=>{
    var total=0
    this.props.loanrepayments.map(
      (item)=>{
        total+=Number(item.interest_paid)
      })

    return total.toFixed(2);
   }

   calculateTotalTotalIn=()=>{
    var total=0
    this.props.loanrepayments.map(
      (item)=>{
        total+=Number(item.total_paid)
      })

    return total.toFixed(2);
   }



   //calculate total principle defaulted
   calculateTotalPrincipledefaulted=()=>{
    var total=0
    this.props.loanschedules.map(
      (item)=>{
        total+=Number(item.principle)
      })

    return total.toFixed(2);
   }

   calculateTotalInterestdefaulted=()=>{
    var total=0
    this.props.loanschedules.map(
      (item)=>{
        total+=Number(item.interest)
      })

    return total.toFixed(2);
   }

   calculateTotalTotalDefaulted=()=>{
    var total=0
    this.props.loanschedules.map(
      (item)=>{
        total+=Number(item.total)
      })

    return total.toFixed(2);
   }



  
    render() {
      return (
        <div style={{padding:20}}>
 <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>
                
                  </Col>
       </Row>

             <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>DAY LOAN REPORT FOR {this.props.date} </h3>
             <h4 style={{fontWeight:'bold'}}>Loan Repayments</h4>
             <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Account Name</th>
                            <th>Account Number</th>
                            <th>Principle In</th>
                            <th>Interest In</th>
                            <th>Total In</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.props.loanrepayments.map(
                          (item)=>(
                            <tr>
                            <td>{item.date}</td>
                            <td>{item.accountName}</td>
                            <td>{item.accountNumber}</td>
                            <td className="align-right">{<CurrencyFormat value={item.principle_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.interest_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.total_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalPrincipleIn()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalInterestIn()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalTotalIn()} displayType={'text'} thousandSeparator={true}/>}</td>
                          </tr>

                      </tbody>
                  </reactstrp.Table>             


             <h4 style={{fontWeight:'bold'}}>Loan schedules</h4>
             <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Account Name</th>
                            <th>Account Number</th>
                            <th>Principle </th>
                            <th>Interest </th>
                            <th>Total </th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.props.loanschedules.map(
                          (item)=>(
                            <tr>
                            <td>{item.date}</td>
                            <td>{item.accountName}</td>
                            <td>{item.accountNumber}</td>
                            <td className="align-right">{<CurrencyFormat value={item.principle} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.interest} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.total} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalPrincipledefaulted()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalInterestdefaulted()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalTotalDefaulted()} displayType={'text'} thousandSeparator={true}/>}</td>
                         
                          </tr>

                      </tbody>
                  </reactstrp.Table>  


             <h4 style={{fontWeight:'bold'}}>Loan Issues</h4>
             <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Account Name</th>
                            <th>Account Number</th>
                            <th>Approved AMount</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.props.loanissues.map(
                          (item)=>(
                            <tr>
                            <td>{item.date}</td>
                            <td>{item.accountName}</td>
                            <td>{item.accountNumber}</td>
                            <td className="align-right">{<CurrencyFormat value={item.approvedamount} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalofIssuance()} displayType={'text'} thousandSeparator={true}/>}</td>                        
                          </tr>
                      </tbody>
                  </reactstrp.Table>   
           
        </div>
      );
    }
  }


class DayLoanReport extends React.Component {

  state = {
    ...initialReportEmailState(),
    users:[],
    loanrepayments:[],
    loanissues:[],
    loanschedules:[],
    dateone:moment().format(dateFormat).toString(),
    datarequested:false,
    companyprofile:{},
    accounts:[],
    creditofficer:'',

   };

   componentDidMount(){
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   
   }else{
      sacco= ''
      bizuserid= ''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/accounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          users:res.data
        })
      })

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {
      this.setState((prev) => ({
        companyprofile: res.data,
        receiving_email: prev.receiving_email || res.data.company_email || '',
      }));
    })


    axios.get(serverconfig.backendserverurl+`/api/accounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          accounts:res.data
        })
    })


  }
 
   handledatechange= (date, dateString) =>{
     this.setState({ dateone: dateString});
   } 


   //calculate total of issuance
   calculateTotalofIssuance=()=>{
    var totalofissuances=0
    this.state.loanissues.map(
      (item)=>{
        totalofissuances+=Number(item.approvedamount)
      })

    return totalofissuances.toFixed(2);
   }


   //calculate total principle in
   calculateTotalPrincipleIn=()=>{
    var total=0
    this.state.loanrepayments.map(
      (item)=>{
        total+=Number(item.principle_paid)
      })

    return total.toFixed(2);
   }

   calculateTotalInterestIn=()=>{
    var total=0
    this.state.loanrepayments.map(
      (item)=>{
        total+=Number(item.interest_paid)
      })

    return total.toFixed(2);
   }

   calculateTotalTotalIn=()=>{
    var total=0
    this.state.loanrepayments.map(
      (item)=>{
        total+=Number(item.total_paid)
      })

    return total.toFixed(2);
   }



   //calculate total principle defaulted
   calculateTotalPrincipledefaulted=()=>{
    var total=0
    this.state.loanschedules.map(
      (item)=>{
        total+=Number(item.principle)
      })

    return total.toFixed(2);
   }

   calculateTotalInterestdefaulted=()=>{
    var total=0
    this.state.loanschedules.map(
      (item)=>{
        total+=Number(item.interest)
      })

    return total.toFixed(2);
   }

   calculateTotalTotalDefaulted=()=>{
    var total=0
    this.state.loanschedules.map(
      (item)=>{
        total+=Number(item.total)
      })

    return total.toFixed(2);
   }


 
   //search sales method
   searchSales=()=>{
      if(this.state.dateone===''){
        alert("Please select date")
        return;
      }

      let form_data = new FormData();
      form_data.append('date', this.state.dateone);
      form_data.append('sacco', sacco);
      form_data.append('creditofficer', this.state.creditofficer);

      submitReportWithEmail({
        reportKey: REPORT_KEYS.DAY_LOAN,
        params: { date: this.state.dateone, sacco, creditofficer: this.state.creditofficer },
        emailReport: this.state.email_report,
        receivingEmail: this.state.receiving_email,
        endpoint: serverconfig.backendserverurl + '/customqueries/getDayLoanReport',
        formData: form_data,
        setLoading: (v) => this.setState({ datarequested: v }),
        onSuccess: (res) => {
          this.setState({
            loanschedules: JSON.parse(res.data.loanschedules),
            loanissues: JSON.parse(res.data.loanissues),
            loanrepayments: JSON.parse(res.data.loanrepayments),
          });
        },
      });
    }

   ////////////////////////////////////
  // USER SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }
 

   ////////////////////////////////////////////
   // RENDERING METHOD HERE
   render() {
       
       if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
          <Spin indicator={antIcon} />
          </div>
        )
  
      }else{

        return(
          <div>
            <div style={{display: "none"}}>
               &nbsp;&nbsp;
              <ReportToPrint
              date={this.state.dateone} 
              loanschedules={this.state.loanschedules} 
              loanissues={this.state.loanissues} 
              loanrepayments={this.state.loanrepayments} 
              ref={el => (this.componentRef = el)} /> 
            </div>
  
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
              <Panel header="DAY LOAN REPORT" key="1">

            <div style={{display:'flex',justifyContent:'flex-start',alignSelf:'flex-start',alignItems:'flex-start'}}> 
              {!this.state.email_report ? (
              <>
              <ReactToPrint
                  trigger={() => 
                  <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                  Print
                  </Button>
                  }
                  content={() => this.componentRef}
                  />
                  &nbsp;&nbsp;

             <ExcelFile filename={"Pisacco - Dayloanreport for "+this.state.dateone} element={<Button type='primary' icon={<DownloadOutlined/>}>Download report (Excel)</Button>}>
                <ExcelSheet data={this.state.loanrepayments} name="Loan repayments">
                    <ExcelColumn label="No" value="no"/>

                    <ExcelColumn label="Date" value="date"/>
                    <ExcelColumn label="Account name" value="accountName"/>
                    <ExcelColumn label="Account number" value="accountNumber"/>
                    <ExcelColumn label="Principle paid" value="principle_paid"/>
                    <ExcelColumn label="Interest paid" value="interest_paid"/>
                    <ExcelColumn label="Total Paid " value="total_paid"/>
                </ExcelSheet>

                <ExcelSheet data={this.state.loanschedules} name="Loan schedules">
                    <ExcelColumn label="No" value="no"/>

                    <ExcelColumn label="Date" value="date"/>
                    <ExcelColumn label="Account name" value="accountName"/>
                    <ExcelColumn label="Account number" value="accountNumber"/>
                    <ExcelColumn label="Principle " value="principle"/>
                    <ExcelColumn label="Interest " value="interest"/>
                    <ExcelColumn label="Total  " value="total"/>
                </ExcelSheet>

                <ExcelSheet data={this.state.loanissues} name="Loan disbursements">
                    <ExcelColumn label="No" value="no"/>

                    <ExcelColumn label="Date" value="date"/>
                    <ExcelColumn label="Account name" value="accountName"/>
                    <ExcelColumn label="Account number" value="accountNumber"/>
                    <ExcelColumn label="Amount" value="approvedamount"/>
                </ExcelSheet>

            </ExcelFile>
         
                  &nbsp;&nbsp;
              </>
              ) : null}
    
                <Form  layout="inline" >
                <FormItem label="Date (Day)">
                <DatePicker defaultValue={moment()} onChange={this.handledatechange} format={dateFormat} />
                </FormItem>

                <FormItem label="Credit Officer"
                     
                      >
                      <Select placeholder="Credit Officer" 
                       value={this.state.creditofficer}
                        onChange={(val)=>{this.setState({creditofficer:val})}} >
                        <Option value={''}>All Officers</Option>
                        {this.state.accounts.map(
                          (ctgry)=>(
                            <Option value={ctgry.id}>{ctgry.username}</Option>
                          ))}
                      </Select>
                  </FormItem>

                <ReportEmailControls
                  emailReport={this.state.email_report}
                  receivingEmail={this.state.receiving_email}
                  onEmailReportChange={(val) => this.setState({ email_report: val })}
                  onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
                  companyEmail={this.state.companyprofile.company_email}
                />

                <FormItem>
                <Button onClick={this.searchSales} type="primary" htmlType="button">{reportSearchButtonLabel(this.state.email_report)}</Button>
                </FormItem> 
                </Form>
               
              </div> 
  
  
             <br></br>
             <h4>Loan Repayments</h4>
             <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Date</th>
                            <th>Account Name</th>
                            <th>Account Number</th>
                            <th>Loan ID</th>

                            <th>Principle In</th>
                            <th>Interest In</th>
                            <th>Total In</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.state.loanrepayments.map(
                          (item)=>(
                            <tr>
                            <td>{item.no}</td>
                            <td>{item.date}</td>
                            <td>{item.accountName}</td>
                            <td>{item.accountNumber}</td>
                            <td>{item.loan_number}</td>

                            <td className="align-right">{<CurrencyFormat value={item.principle_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.interest_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.total_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalPrincipleIn()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalInterestIn()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalTotalIn()} displayType={'text'} thousandSeparator={true}/>}</td>
                          </tr>

                      </tbody>
                  </reactstrp.Table>             


             <h4>Loan Schedules</h4>
             <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Date</th>
                            <th>Account Name</th>
                            <th>Account Number</th>
                            <th>Loan ID</th>

                            <th>Principle </th>
                            <th>Interest </th>
                            <th>Total </th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.state.loanschedules.map(
                          (item)=>(
                            <tr>
                            <td>{item.no}</td>
                            <td>{item.date}</td>
                            <td>{item.accountName}</td>
                            <td>{item.accountNumber}</td>
                            <td>{item.loan_number}</td>

                            <td className="align-right">{<CurrencyFormat value={item.principle} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.interest} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td className="align-right">{<CurrencyFormat value={item.total} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalPrincipledefaulted()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalInterestdefaulted()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalTotalDefaulted()} displayType={'text'} thousandSeparator={true}/>}</td>
                         
                          </tr>

                      </tbody>
                  </reactstrp.Table>  


             <h4>Loan Issues</h4>
             <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Date</th>
                            <th>Account Name</th>
                            <th>Account Number</th>
                            <th>Loan ID</th>
                            <th>Approved AMount</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.state.loanissues.map(
                          (item)=>(
                            <tr>
                            <td>{item.no}</td>
                            <td>{item.date}</td>
                            <td>{item.accountName}</td>
                            <td>{item.accountNumber}</td>
                            <td>{item.loan_number}</td>

                            <td className="align-right">{<CurrencyFormat value={item.approvedamount} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalofIssuance()} displayType={'text'} thousandSeparator={true}/>}</td>                        
                          </tr>

                      </tbody>
                  </reactstrp.Table> 

 
              </Panel>
              </Collapse>
  
  
          </div>
  
      )        

      }

 
   }
}

export default DayLoanReport; 
